import LabelProvider from "core/components/label/LabelProvider";
export default LabelProvider.create({

	LearnersCount: {
		k: "organization.stats.user.count.help",
		v: "Number of learners in your organization."
    },
    
    Members: {
		k: "organizations.stats.user.count.label",
		v: "Members"
    },
    DiscussionThreadCount: {
        k:"organization.stats.discussion.count.help",
        v:"Number of discussion threads from your users."
    },
    Discussions: {
        k:"organizations.stats.discussion.count.label",
        v:"Discussions"
    },
    CoursesCount: {
        k: "organization.stats.courses.count.help",
        v:""
    },
    Courses: {
        k:"organizations.stats.courses.count.label",
        v:"Courses"
    }
});



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/stats/OrganizationStats.labels.ts